/**
 * Piercing jewelry options: Jewelry type → Gauges → Lengths.
 * Lengths are shared across all gauges for a jewelry type.
 */
export const piercingJewelryOptions = [
  {
    jewelry: "Curve",
    gauges: ["14G", "16G"],
    lengths: ["7/16", "3/8", "5/8"],
  },
  {
    jewelry: "Labret",
    gauges: ["14G", "16G"],
    lengths: ["7/16", "3/8", "1/4", "1/2"],
  },
  {
    jewelry: "Nose Corkscrew",
    gauges: ["19G"],
    lengths: ["3/16"],
  },
  {
    jewelry: "Circular",
    gauges: ["16G"],
    lengths: ["3/8"],
  },
  {
    jewelry: "Nipple Straight bar",
    gauges: ["14G", "16G"],
    lengths: ["1/2", "5/8"],
  },
  {
    jewelry: "Tongue Straight bar",
    gauges: ["14G"],
    lengths: ["3/4"],
  },
  {
    jewelry: "Ear Stud",
    gauges: ["20G"],
    lengths: [],
  },
  {
    jewelry: "Industrial straight bar",
    gauges: ["14G", "16G"],
    lengths: ["1 3/4 in"],
  },
  {
    jewelry: "Staple Bar",
    gauges: ["16G"],
    lengths: ["10mm", "12mm"],
  },
];
